export interface ICommentProps {
  id: number;
  name: string;
  postedAt: string;
  text: string | React.ReactNode;
  updatedAt: string | null;
  onEdit: (id: number, userId: number) => void;
  onDelete: (id: number, userId: number) => void;
  userId: number;
}

export enum FeedbackTypeId {
  comment = 1,
  addEvaluation = 2,
  editEvaluation = 3,
  deleteEvaluation = 4,
  rejectedCandidate = 5,
  aiEvaluationSummary = 6,
}

export enum ReactionTypeId {
  unReact = 0,
  like = 1,
  dislike = 2,
}

export interface IGetFeedback {
  feedbackId: number;
  userId: number;
  name: string;
  feedbackTypeId: FeedbackTypeId;
  data: {
    job: {
      title: string;
    };
    summary: string;
    interviewId: number;
    interviewInvitationId: number;
    applicationEvaluationId: number;
    reaction: {
      id: number;
      name: string;
    },
    videoUrl: string;
    score: string;
    duration: string;
    evaluationId: number;
    kitTitle: string;
    stageName: string;
    comment?: string;
    rejectionReason?: string;
  };
  createdAt: string;
  updatedAt: string | null;
  isLastVersion?: Boolean
}

export interface IAddComment {
  applicationId: number;
  text: string;
  mentionedUserIds: {id: number}[];
}
